import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report, ReportUIRenderer, ReportUIRendererProps } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import { ComponentType } from "react";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { FileUtils } from "@singularsystems/neo-core";
import DividendResolutionCriteria from "./DividendResolutionCriteria";

@NeoReport("DividendResolution", { category: ReportCategory.InvestorReports })
export default class DividendResolutionReport extends Report<DividendResolutionCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(DividendResolutionCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.dated} />
                    <Neo.FormGroup bind={this.criteria.meta.entityId} select={{itemSource: this.dataCache.entities}} />
                    <Neo.FormGroup bind={this.criteria.meta.resolutionNumber} />
                    <Neo.FormGroup bind={this.criteria.meta.resolutionYear} numProps={{ formatString: "#"}} />
                </div>
                <div>
                </div>
            </Neo.GridLayout>
        </div>;
    }

    get uiRenderer(): ComponentType<ReportUIRendererProps> {
        return DividendResolutionReportUIRenderer;
    }
}

class DividendResolutionReportUIRenderer extends ReportUIRenderer {
    
    renderActionButtons(): React.ReactNode {
        
        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file-word"
                variant="secondary"
                onClick={() => this.downloadWordDocument()}>
                    Word
            </Neo.Button>
        </>
    }

    private async downloadWordDocument() {
        const apiClient = AppService.get(DomainTypes.ApiClients.Reporting);
        const criteria = (this.report as DividendResolutionReport).criteria.toJSObject();

        const response = await this.props.taskRunner.waitFor(apiClient.getDividendResolutionFile(criteria), { allowPost: true });

        FileUtils.showSaveFile(response);
    }
}